import {encloseInDisplayQuotes} from "@/app/utils/StringUtils";

export default function(item) {
    return encloseInDisplayQuotes(item.trim());
}